enum EtapaEnum {
  agendamento = 'Agendamento',
  autorizacao = 'Autorizacao',
  agenciaTransfusional = 'AgenciaTransfusional',
}

export default EtapaEnum
